import eventSettingsSchema from '../modules/eventSettings/eventSettings.graphql';
import eventSchema from '../modules/events/events.graphql';
import changelogSchema from '../modules/changelog/changelog.graphql';
import eventTriggerSettingSchema from '../modules/eventTriggerSetting/eventTriggerSetting.graphql';

export default [
  eventSettingsSchema,
  eventSchema,
  changelogSchema,
  eventTriggerSettingSchema,
];
